// Translations
import landing from '../views/landing/translations/ru'

// Translation: Two-factor authentication (Russian)
export default Object.freeze({
	name: '',
	views: { landing }
})
